import {Mutations} from "vuex-smart-module";
import QrServerState, {QrServerStatus} from "@/store/modules/qr-server/qr-server-state";
import QrServerCodeData from "@/http/data/qr-server-code-data";
import QrServerLogEntryData from "@/http/data/qr-server-log-entry-data";
import QrServerLogFiltersData from "@/http/data/qr-server-log-filters-data";
import {QrServerLogMetaData} from "@/http/data/qr-server-log-page-data";

export default class QrServerMutations extends Mutations<QrServerState> {
    setCodes(codes: QrServerCodeData[]): void {
        this.state.codes = codes;
    }

    setCodesStatus(status: QrServerStatus): void {
        this.state.codesStatus = status;
    }

    setLogs(logs: QrServerLogEntryData[]): void {
        this.state.logs = logs;
    }

    setLogsStatus(status: QrServerStatus): void {
        this.state.logsStatus = status;
    }

    setLogsMeta(meta: QrServerLogMetaData | null): void {
        this.state.logsMeta = meta;
    }

    setSelectedLogsPage(page: number): void {
        this.state.selectedLogsPage = page;
    }

    setLogFilterOptions(filters: QrServerLogFiltersData): void {
        this.state.logFilterOptions = filters.clone();
    }

    setLogFilters(filters: QrServerLogFiltersData): void {
        this.state.logFilters = filters.clone();
    }

    setLastFetchedLogFilters(filters: QrServerLogFiltersData): void {
        this.state.lastFetchedLogFilters = filters.clone();
    }

    setIsInitialized(value: boolean): void {
        this.state.isInitialized = value;
    }
}
